
import { Component, Vue } from 'vue-property-decorator'
import InputFileBase from '@/components/atoms/InputFileBase.vue'

/**
 * ファイル選択
 */
@Component({
  components: {
    InputFileBase,
  },
})
export default class InputFile extends Vue {
  /**
   * 入力時のイベント
   *
   * @param files 入力値
   */
  private changeEvent(files: FileList | null): void {
    this.$emit('change', files)
  }
}
